import { combineReducers } from 'redux'
import misc from './misc'
import swap from './swap'

export default combineReducers({
  misc,
  swap,
})
